export const ages = {
  'age-1': {
    label: 'Ages 11-13',
    results: '11-13',
    value: 'ElevenToThirteen',
    min: 11,
    max: 13
  },
  'age-2': {
    label: 'Ages 13-14',
    results: '13-14',
    value: 'ThirteenToFourteen',
    min: 13,
    max: 14
  }
}

export const defaultAge = {
  label: 'Ages 11-14',
  results: '11-14',
  min: 11,
  max: 14
}

export const fromValue = (value, obj, defaultValue = {}) => {
  const key = Object.keys(obj).find(key => obj[key].value === value)
  return key != null ? obj[key] : defaultValue
}
